import React from "react";
import CategoryBudgetTableContainer from "../text/CategoryBudgetTableContainer";
import BudgetTableContainer from "../text/BudgetTableContainer";
import TextContainer from "../text/TextContainer";
import TextArrayContainer from "../text/TextArrayContainer";
import DisplayComments from "../text/DisplayComments";
import ProjectTitle from "../text/ProjectTitle";

const ProposalComp = ({ project }) => {
  return (
    <>
      <ProjectTitle title={project.name} />
      <TextContainer label="Name of Community" content={project.community} />
      <TextContainer label="Address 1" content={project.community_address1} />
      <TextContainer label="Address 2" content={project.community_address2} />
      <TextContainer label="Province" content={project.province} />
      <TextContainer label="Country" content={project.country} />
      <TextContainer
        label="Community Contact Name"
        content={`${project.creator?.first_name} ${
          project.creator.other_names ? project.creator.other_names + " " : ""
        }${project.creator?.last_name}`}
      />
      <TextContainer
        label="Community Contact Email"
        content={project.creator?.email}
      />
      <TextContainer
        label="Community Contact Number"
        content={project.creator?.phone || "NA"}
      />
      <TextContainer
        label="PDO Contact Name"
        content={`${project.partners[0]?.first_name} ${
          project.partners[0]?.other_names
            ? project.partners[0]?.other_names + " "
            : ""
        }${project.partners[0]?.last_name}`}
      />
      <TextContainer
        label="PDO Contact Email"
        content={project.partners[0]?.email}
      />
      <TextContainer
        label="PDO Contact Number"
        content={project.partners[0]?.phone || "NA"}
      />
      <TextContainer
        label="Planned Start Date"
        content={new Date(project.planned_start_date).toDateString()}
      />
      <TextContainer
        label="Planned End Date"
        content={new Date(project.planned_end_date).toDateString()}
      />
      <TextContainer
        label="Currency"
        content={`${
          project.currency?.name + " (" + project.currency?.symbol + ")"
        }`}
      />

      {/* Display Comment */}
      <DisplayComments comments={project.comments} />

      {/* Content */}

      <TextContainer label="Background" isHTML content={project.description} />
      <TextContainer isHTML label="Goal" content={project.aim} />
      <TextContainer isHTML label="Purpose" content={project.purpose} />
      <TextArrayContainer label="Activities" content={project.activities} />
      <TextArrayContainer label="Results" content={project.expected_results} />
      <TextArrayContainer label="Objectives" content={project.objectives} />
      <TextContainer
        isHTML
        label="Selected Indicators"
        content={project.selected_indicators}
      />
      <TextContainer
        isHTML
        label="Sustainability Plan"
        content={project.sustainability_plan}
      />
      <TextContainer
        isHTML
        label="Justification"
        content={project.justification}
      />
      <TextContainer
        isHTML
        label="Monitoring and Supervision"
        content={project.monitoring_supervision}
      />
      <TextContainer
        isHTML
        label="How this project helps address the issues of the GC26 & DC27"
        content={project.issues}
      />
      {/*  */}
      <TextContainer
        label="Target Group"
        content={project.stakeholder_target_group}
      />
      <TextContainer
        label="Male Beneficiaries"
        content={project.male_beneficiaries}
      />
      <TextContainer
        label="Female Beneficiaries"
        content={project.female_beneficiaries}
      />

      {/* Budget */}
      <div className="w-full overflow-x-auto">
        <BudgetTableContainer label="Budget" content={project.budget || []} />
      </div>

      {/* Budget by Category*/}
      <div className="w-full overflow-x-auto">
        <CategoryBudgetTableContainer
          label="Budget by Category"
          content={project.catBudget || []}
        />
      </div>

      {/* Summary End */}
    </>
  );
};

export default ProposalComp;
